import { ICopyable } from '../controls/common/icopyable';
import { CustomerType } from './customer-type';
import { ICustomer } from './interfaces/customer.interface';
import { IDisplayableItem } from './interfaces/displayable-item.interface';

export class Customer implements ICopyable<Customer>, IDisplayableItem {
    public id: number = null;
    public organizationId: string = null;
    public code: string = null;
    public name: string = null;
    public address1: string = null;
    public address2: string = null;
    public postalCode: string = null;
    public city: string = null;
    public country: string = null;
    public siret: string = null;
    public phoneNumber: string = null;
    public mobileNumber: string = null;
    public faxNumber: string = null;
    public email: string = null;
    public csid: string = null;
    public type: CustomerType = null;

    public createCopy(): Customer {
        const instance = new Customer();
        instance.id = this.id;
        instance.organizationId = this.organizationId;
        instance.code = this.code;
        instance.name = this.name;
        instance.address1 = this.address1;
        instance.phoneNumber = this.phoneNumber;
        instance.faxNumber = this.faxNumber;
        instance.address2 = this.address2;
        instance.postalCode = this.postalCode;
        instance.city = this.city;
        instance.country = this.country;
        instance.siret = this.siret;
        instance.phoneNumber = this.phoneNumber;
        instance.mobileNumber = this.mobileNumber;
        instance.faxNumber = this.faxNumber;
        instance.email = this.email;
        instance.csid = this.csid;
        instance.type = this.type;

        return instance;
    }

    public static createFormCopy(customer: Customer): ICustomer {
        const instance = new Customer();
        instance.id = customer.id;
        instance.organizationId = customer.organizationId;
        instance.code = customer.code;
        instance.name = customer.name;
        instance.address1 = customer.address1;
        instance.phoneNumber = customer.phoneNumber;
        instance.faxNumber = customer.faxNumber;
        instance.address2 = customer.address2;
        instance.postalCode = customer.postalCode;
        instance.city = customer.city;
        instance.country = customer.country;
        instance.siret = customer.siret;
        instance.phoneNumber = customer.phoneNumber;
        instance.mobileNumber = customer.mobileNumber;
        instance.faxNumber = customer.faxNumber;
        instance.email = customer.email;
        instance.csid = customer.csid;
        instance.type = customer.type;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.organizationId = other.organizationId;
        this.code = other.code;
        this.name = other.name;
        this.address1 = other.address1;
        this.phoneNumber = other.phoneNumber;
        this.faxNumber = other.faxNumber;
        this.address2 = other.address2;
        this.postalCode = other.postalCode;
        this.city = other.city;
        this.country = other.country;
        this.siret = other.siret;
        this.phoneNumber = other.phoneNumber;
        this.mobileNumber = other.mobileNumber;
        this.faxNumber = other.faxNumber;
        this.email = other.email;
        this.csid = other.csid;
        if (other.type == 0) {
            this.type = CustomerType.Final;
        } else if (other.type == 1) {
            this.type = CustomerType.Delivery;
        }
    }

    public getDisplayName() {
        return `${this.name}`;
    }

    get displayName(): string {
        return `${this.name} (${this.code})`;
    }
}
